import { useSelector } from "react-redux";
import { useCheckSessionQuery } from "../Redux/service/Users/AuthUsers";

const usePermission = (moduleKey) => {
  // const token = localStorage.getItem("token");
  const user = useSelector((state) => state.users.auth);
  const { data, error } = useCheckSessionQuery();
  if (data?.success === false || error?.data?.success === false)
    return {
      view: false,
      create: false,
      edit: false,
      delete: false,
    };
  const userPermissions = Array.isArray(user?.permissions)
    ? user.permissions
    : [];

  const permissions =
    [
      ...userPermissions,
      {
        actions: {
          edit: false,
          view: true,
          create: true,
          delete: false,
        },
        moduleKey: "SETUPACCOUNT",
        name: "setup.account",
      },
    ] || [];

  // ** ---- Debugging: Log the permissions array
  // ** ---- Use it to troubleshoot if the moduleKey is not found
  console.log("permissions", permissions);

  const modulePermission = permissions.find(
    (perm) => perm.moduleKey === moduleKey,
  );

  // ** ---- Debugging: Log the modulePermission
  // ** ---- Use it to troubleshoot if the moduleKey is not found
  // console.log("modulePermission", modulePermission);

  if (!modulePermission) {
    return {
      view: false,
      create: false,
      edit: false,
      delete: false,
    };
  }

  return modulePermission.actions;
};

export default usePermission;
